import { useEffect } from 'react';

export function useScrollPosition(callback: () => void): void {
  useEffect(() => {
    function listener() {
      callback();
    }

    window.addEventListener('scroll', listener, { passive: true });
    window.addEventListener('resize', listener, { passive: true });
    return () => {
      window.removeEventListener('scroll', listener);
      window.removeEventListener('resize', listener);
    };
  }, [callback]);
}
